import React from 'react';

// import {
//   Input,
// } from 'reactstrap';
import classNames from 'classnames';

const CustomBirthday = ({
  customDay,
  customMonth,
  customYear,
  dRef,
  mRef,
  yRef,
  handleKeyDay,
  handleKeyMonth,
  handleKeyYear,
  mbirthday,
  birthday,
  dPlaceholder,
  mPlaceholder,
  yPlaceholder,
}) => {
  return (
    <div className={classNames("custom-birthday", {
      'custom-birthday-disable': mbirthday
    })}>
      <input type='text' className='custom-birthday-day' placeholder={dPlaceholder} ref={dRef} value={customDay || dPlaceholder} onKeyDown={handleKeyDay} disabled={mbirthday} />
      <span className='custom-birthday-slot'>/</span>
      <input type='text' className='custom-birthday-month' placeholder={mPlaceholder} ref={mRef} value={customMonth || mPlaceholder} onKeyDown={handleKeyMonth} disabled={mbirthday} />
      <span className='custom-birthday-slot'>/</span>
      <input type='text' className='custom-birthday-year' placeholder={yPlaceholder} ref={yRef} value={customYear || yPlaceholder} maxLength={4} onKeyDown={handleKeyYear} disabled={mbirthday} />
    </div>
  );
};

export default CustomBirthday;
